export const AUTH_STATE = {
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
  AUTHENTICATED: 'AUTHENTICATED',
  FETCHING: 'FETCHING',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR'
}
